"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Component = function Component(props) {
  var left = props.left,
    top = props.top,
    width = props.width,
    height = props.height;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].placeholder,
    style: {
      left: "".concat(left, "%"),
      top: "".concat(top, "%"),
      width: "".concat(width, "%"),
      height: "".concat(height, "%")
    }
  }, props.children);
};
Component.propTypes = {
  left: _propTypes["default"].number,
  top: _propTypes["default"].number,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  children: _propTypes["default"].node
};
var _default = exports["default"] = Component;